import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import TransactionList from './components/TransactionList';
import TransactionDetail from './components/TransactionDetail';
import Transfer from './components/Transfer';
import WalletManagement from './components/WalletManagement';
import TokenManagement from './components/TokenManagement';
import UserManagement from './components/UserManagement';
import { FailedTransactions } from './components/FailedTransactions';
import CallbackLogs from './components/CallbackLogs';
import OutboundCallbacks from './components/OutboundCallbacks';
import Layout from './components/Layout';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500 mx-auto"></div>
          <p className="mt-4 text-slate-400">Loading...</p>
        </div>
      </div>
    );
  }
  
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-slate-900">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="transactions" element={<TransactionList />} />
              <Route path="transactions/:id" element={<TransactionDetail />} />
              <Route path="transfer" element={<Transfer />} />
              <Route path="failed-transactions" element={<FailedTransactions />} />
              <Route path="wallets" element={<WalletManagement />} />
              <Route path="tokens" element={<TokenManagement />} />
              <Route path="users" element={<UserManagement />} />
              <Route path="callbacks" element={<CallbackLogs />} />
              <Route path="outbound-callbacks" element={<OutboundCallbacks />} />
            </Route>
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
